<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
  >
    <v-card>
      <v-form>
        <v-card-text class="text-center text-h6">
          {{message}}
          <p v-if="subtitle" class="text--secondary text-body-2 mb-0">{{subtitle}}</p>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-spacer />
              <v-col cols="3">
                <v-btn
                  rounded
                  dark
                  small
                  block
                  outlined
                  color="primary"
                  @click="handle('no')"
                >
                  {{ $t('common.no') }}
                </v-btn>
              </v-col>
              <v-col cols="3">
                <v-btn
                  rounded
                  dark
                  small
                  block
                  color="success"
                  @click="handle('yes')"
                >
                  {{ $t('common.yes') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  created () {
    this.$eventBus.$on('OPEN_CONFIRM_MODAL', this.handleOpenModalEvent)
    this.$eventBus.$on('CLOSE_CONFIRM_MODAL', this.handleCloseModalEvent)
  },
  data () {
    return {
      dialog: false,
      message: '',
      subtitle: '',
      handlers: { }
    }
  },
  methods: {
    handleOpenModalEvent (payload) {
      Object.assign(this, payload)
      this.message = payload.scope.message
      this.subtitle = payload.scope.subtitle
      this.dialog = true
    },
    handleCloseModalEvent () {
      this.dialog = false
    },
    handle (decision) {
      this.dialog = false
      this.handlers[decision] && this.handlers[decision]()
    }
  }
}
</script>
